import { t } from "../i18n/index.ts";
import type { PageProps } from "../lib/state.ts";
import { PageHeader } from "../ui/PageHeader.tsx";
import { CommitList } from "./history/commitList.tsx";

export function History({ space }: PageProps) {
  return (
    <>
      <PageHeader title={t("history.title")} />
      <CommitList space={space} />
    </>
  );
}
